'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRvHookup = function MdRvHookup(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 3.4l5 5-5 5v-3.4h-13.4v-3.4h13.4v-3.2z m1.6 20v-5h-6.6v5h6.6z m-11.6 10c0.9 0 1.6-0.8 1.6-1.8s-0.7-1.6-1.6-1.6-1.8 0.7-1.8 1.6 0.8 1.8 1.8 1.8z m15-5h3.2v3.2h-13.2c0 2.8-2.3 5-5 5s-5-2.2-5-5h-3.4c-1.8 0-3.4-1.4-3.4-3.2v-5h11.8v-5h-6.8v3.2l-5-5 5-5v3.4h18.4c1.8 0 3.4 1.6 3.4 3.4v10z' })
        )
    );
};

exports.default = MdRvHookup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/rv-hookup.js
// module id = 3282
// module chunks = 0